module.exports = __webpack_public_path__ + "static/jardins_all_lagarto_mobile-4f3a593ea950d83892661a1beb431278.jpg";